import useSWR from 'swr'
import useSearchParams from './use-search-params'
import useLocalStorage from './use-local-storage'
import fetcher, { PartnerDetails, InvalidPartnerDetails } from './fetch-promo'

const sanitiseId = (id: string): string =>
  id.replace(/\W/g, '').substr(0, 32)

const usePartnerPromo = (): PartnerDetails | InvalidPartnerDetails => {
  const { partner = '' } = useSearchParams()
  const paramId = sanitiseId(partner)
  const [storedId, setStoredId, removeStoredId] = useLocalStorage<string>(
    'partner-promo',
    paramId,
    86400
  )
  const id = paramId || storedId

  const { data, error } = useSWR<PartnerDetails | InvalidPartnerDetails>(
    id ? `/promo-partners/${id}.json` : null,
    fetcher
  )

  // Remove stored ID if new promo is inactive
  if (data && !data.isActive && storedId) removeStoredId(storedId)
  // Store new ID if promo is active
  if (data && data.isActive && id !== storedId) setStoredId(id)
  
  if (error) return { code: id, isValid: false }
  return data as PartnerDetails | InvalidPartnerDetails
}

export default usePartnerPromo
